module.exports = __webpack_public_path__ + "static/img/jinYueHongTaiLogo.fd74bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jinYueHongTaiLogo.jpg
// module id = Oyqp
// module chunks = 63